module.exports = __webpack_public_path__ + "img/chevron-down-white.8f5a2e75.svg";